const skills = {
  languages: ['JavaScript', 'TypeScript', 'HTML', 'CSS/SCSS', 'PHP', 'Java'],
  frameworks: ['React', 'React Native', 'Flutter', 'Angular', 'Bootstrap', 'WordPress'],
  tools: ['Cursor', 'Figma', 'IntelliJ', 'Visual Studio'],
  service: ['Google Firebase', 'GoogleMap', 'Google Analytics', 'Video SDK', 'Stripe'],
  versionControl: ['GitLab', 'GitHub', 'BitBucket'],
  testing: ['Jest'],
  projectManagement: ['Jira', 'Trello'],
  communication: ['Google Meet', 'Zoom', 'Microsoft Teams'],
  other: ['English', 'Thai', 'Chinese'],
};

export default skills;
